var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBackgroundImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 422,
    viewBox: "0 0 1440 422",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6273_56571)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 422,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 160,
    fill: "#F3F8FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_6273_56571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-480 0H1920V87.5555L-480 387.555V0Z",
    fill: "#F3F8FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1320 162.006L1786.67 103.653V174.764L1320 233.117V162.006Z",
    fill: "#DDEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840 151.787L1520 66.4443V137.555L840 222.898V151.787Z",
    fill: "#C9DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.78 58.3522L1484.44 0V71.1111L1017.78 129.463V58.3522Z",
    fill: "#145DD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80 266.463L386.667 208.11V279.221L-80 337.574V266.463Z",
    fill: "#DDEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-248.889 358.672L217.778 300.32V371.431L-248.889 429.783V358.672Z",
    fill: "#145DD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_6273_56571",
    x: -591.111,
    y: -111.111,
    width: 2622.22,
    height: 609.778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 55.5556
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6273_56571"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6273_56571",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6273_56571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 422,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBackgroundImage);
export default __webpack_public_path__ + "static/media/header-background-Image.fbf8d2794478720b70f3643afc0808a6.svg";
export { ForwardRef as ReactComponent };